import "./Footer.css";

export default function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-inner">
        <span className="footer-brand-text">© {new Date().getFullYear()} Saar 3</span>
        <span className="footer-build-dot" aria-hidden="true"></span>
      </div>
    </footer>
  );
}
